import { mergeToNewObject } from '../../../util/object.helpers'

import { EARN_VIA_ACTION } from '../../../constants/actions'
import { CUSTOM_BRAND_ID } from '../../../constants/pointsExchange'

export const earnViaProfile = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case EARN_VIA_ACTION.GET_STATS:
      return mergeToNewObject(state, {
        statsProcessing: true
      })

    case EARN_VIA_ACTION.GET_STATS_SUCCESS:
      return mergeToNewObject(state, {
        statsProcessing: false,
        stats: payload
      })

    case EARN_VIA_ACTION.GET_STATS_FAILED:
      return mergeToNewObject(state, {
        statsProcessing: false
      })

    case EARN_VIA_ACTION.GET_USERNAME_BY_TID_SUCCESS:
      return mergeToNewObject(state, {
        screenName: payload.username
      })

    case EARN_VIA_ACTION.GET_UGC_SUCCESS:
      return mergeToNewObject(state, {
        posts: payload
      })

    case EARN_VIA_ACTION.CHANGE_STATE:
      return mergeToNewObject(state, { [payload.property]: payload.value })

    case EARN_VIA_ACTION.GET_URL_FOR_SOCIAL_CONNECT:
      return mergeToNewObject(state, {
        currentBrandId: payload.brandId,
        connecting: true,
        error: {}
      })

    case EARN_VIA_ACTION.GET_URL_FOR_SOCIAL_CONNECT_SUCCESS:
      return mergeToNewObject(state, {
        channelName: { [payload.brandId]: payload.data.pusherChannel }
      })

    case EARN_VIA_ACTION.GET_URL_FOR_SOCIAL_CONNECT_FAILED:
      return mergeToNewObject(state, {
        connecting: false
      })

    case EARN_VIA_ACTION.HANDLE_SOCIAL_LOGIN_STATUS:
      const { data, brandId } = payload
      const screenName = data?.username
      return mergeToNewObject(state, {
        connecting: !screenName,
        ...(brandId === CUSTOM_BRAND_ID.X && { screenName })
      })

    default:
      return state
  }
}

const INITIAL_STATE = {
  currentBrandId: '',
  statsProcessing: false,
  screenName: '',
  channelName: {},
  connecting: false,
  stats: {
    like: 0,
    reply: 0,
    repost: 0
  },
  posts: [],
  error: {}
}

export const EARN_VIA_PROFILE_DISPATCH = {
  CONNECTING: 'connecting',
  CHANNEL_NAME: 'channelName',
  ERROR: 'error'
}
